module.exports = __webpack_public_path__ + "static/media/20190916erwm.a9b44ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/20190916erwm.png
// module id = 39
// module chunks = 0